import { render, staticRenderFns } from "./RenunciaList.html?vue&type=template&id=20ed6134&external"
import script from "./RenunciaList.vue?vue&type=script&lang=js"
export * from "./RenunciaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports